export const USER_NOTE_SYMPTOM_ID = "___USER_NOTES___";
